import { z } from 'zod';

export const CommonProgressItem = z.object({
  maxUnlockedEpisodeId: z.number().nullish(),
  nextReleaseTs: z.number().nullish(),
  seriesId: z.string(),
  episodeId: z.number().nullish(),
  testBranch: z.string().nullish(),
  timestamp: z.number(),
  isCountdownReached: z.boolean().optional(),
  isInLibrary: z.boolean().optional(),
  completedAtChapterCnt: z.number().nullish(),
});

export const ReadingProgressItem = CommonProgressItem.extend({
  contentId: z.number().nullish(),
  contentDataId: z.number().nullish(),
  version: z.number(),
  dataVersion: z.number().nullish(),
  scrollPosition: z.number().nullish(),
});
export const ReadingProgressList = z.record(z.string(), ReadingProgressItem);
export type ReadingProgressList = z.infer<typeof ReadingProgressList>;

export const ListeningProgressItem = CommonProgressItem.extend({
  episodePosition: z.number(),
});
export const ListeningProgressList = z.record(z.string(), ListeningProgressItem);
export type ListeningProgressList = z.infer<typeof ListeningProgressList>;
